export type RedirectProps = {
	pageUrl:string
}

export const redirect = (props:RedirectProps) => {
	window.location.assign(props.pageUrl)
}



// WEBPACK FOOTER //
// ./src/common/common.ts